import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'flatHeadlessJobs';

export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const CHANGE_PAGE = `${NAMESPACE}/CHANGE_PAGE`;
export const CHANGE_PER_PAGE = `${NAMESPACE}/CHANGE_PER_PAGE`;
export const RESET_PAGE = `${NAMESPACE}/RESET_PAGE`;

export const ARCHIVED_JOBS_GET = createApiConstants(NAMESPACE, 'ARCHIVED_JOBS_GET');
